import React from "react";
import YogaGirl from "../assets/yogaaa.png";
import bat from "../assets/bat.png";

export const WhatWeStandFor = () => {
  return (
    <div className="bg-black px-4 sm:px-6 lg:px-12 py-12">
      <div className="bg-white rounded-xl px-4 sm:px-10 md:px-16 py-12 text-black">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
          <div className="space-y-8 text-center md:text-left">
            <div>
              <p className="text-[18px] md:text-[20px] xl:text-[24px] uppercase font-langit">
                Allround Fitness
              </p>
              <p className="text-gray-600 font-articulat mt-2 text-[16px] md:text-[18px] xl:text-[20px]">
                Integrate cardio, strength, flexibility,
                <br className="hidden md:block" />
                and martial discipline for complete
                <br className="hidden md:block" />
                wellness.
              </p>
            </div>
            <div>
              <p className="text-[18px] md:text-[20px] xl:text-[24px] uppercase font-langit">
                Community Spirit
              </p>
              <p className="text-gray-600 font-articulat mt-2 text-[16px] md:text-[18px] xl:text-[20px]">
                Connect with coaches and peers
                <br className="hidden md:block" />
                in a supportive, motivating
                <br className="hidden md:block" />
                environment.
              </p>
            </div>
          </div>
          <div className="text-center py-6 md:py-0  md:pr-5">
            <p className="text-[32px] sm:text-[48px] lg:text-[64px] xl:text-[120px] font-league uppercase leading-none">
              What We
              <br />
              Stand For
            </p>
          </div>
          <div className="space-y-8 text-center md:text-left">
            <div>
              <p className="text-[18px] md:text-[20px] xl:text-[24px] uppercase font-langit">
                Lifelong Engagement
              </p>
              <p className="text-gray-600 font-articulat mt-2 text-[14px] md:text-[18px] xl:text-[20px]">
                Professional coaching and fun
                <br className="hidden md:block" />
                programs for all ages and skill
                <br className="hidden md:block" />
                levels.
              </p>
            </div>
            <div>
              <p className="text-[18px] md:text-[20px] xl:text-[24px] uppercase font-langit">
                Mind-Body Balance
              </p>
              <p className="text-gray-600 font-articulat mt-2 text-[16px] md:text-[18px] xl:text-[20px]">
                From high‐energy rallies to
                <br className="hidden md:block" />
                calming yoga sessions — balance
                <br className="hidden md:block" />
                is at the core.
              </p>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-7 gap-6 xl:gap-12 mt-16">
          <div className="relative h-[300px] md:h-[500px] lg:h-[400px] xl:h-[565px] lg:col-span-4">
            <div className="absolute bottom-0 left-0 right-0 h-[75%] md:h-[70%] lg:h-[75%] xl:h-[86%] bg-black rounded-xl z-0" />
            <h1 className="absolute top-[50%] lg:top-[55%] xl:top-[36%]   left-0 right-0 text-[70px] md:text-[150px] lg:text-[120px] xl:text-[200px] font-extrabold text-[#1a1a1a] uppercase tracking-wide font-league text-center z-10 leading-none">
              BADMINTON
            </h1>
            <img
  src={bat}
  alt="Fitness Guy"
   style={{
    filter: "brightness(80%) contrast(130%) ",
  }}
  className="absolute bottom-0 left-5 md:left-44 lg:left-20 xl:left-44 transform -translate-x-1/2 
             h-[225px] md:h-[350px] lg:h-[300px] xl:h-[477px] object-contain z-20"
/>

          </div>

          <div className="relative h-[250px] md:h-[400px] xl:h-[565px] lg:col-span-3">
            <div className="absolute bottom-0 left-0 right-0 h-[55%] bg-[#4C4C4C] rounded-xl z-0" />
              <div className="absolute bottom-10 md:bottom-20 lg:bottom-16 xl:bottom-28 left-0 right-10  xl:right-28 h-[55%] z-10 flex items-center justify-center pl-8">
              <img
                src={YogaGirl}
                alt="Yoga Woman"
                className="h-[250px] md:h-[450px] lg:h-[400px] xl:h-[620px] object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
